import { SetStateAction, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import UnForm from "../../../../Components/Form";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import { CadastrarVisitaVendasController } from "../../../../Controllers/Vendas/Compromisso/CompromissoController";
import { ICompromissoRequest } from "../../../../Interfaces/Vendas/Compromisso/CompromissoInterface";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useHistoricoContext } from "../../../../Context/Historico";
import { useAtendimentoPage } from "../../../../Context/AtendimentoPage";
import { IListarCasoResponse } from "../../../../Interfaces/Vendas/Caso/CasoInterface";

import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
import {
    ListarHorariosAgendadosPontoVendaController,
    ListarPontoVendasDisponivelController,
} from "../../../../Controllers/Vendas/GestãoDeVisitas/GestãoDeVisitasControllers";

interface ICadastrarVisita {
    setShow: (value: SetStateAction<boolean>) => void;
    caso?: IListarCasoResponse;
    updateList?: (...args: any[]) => Promise<IListarCasoResponse[]>;
}

export default function CadastrarVisita(props: ICadastrarVisita) {
    const FormMethods = useForm();

    const [dataVisita, setDataVisita] = useState("");
    const [horarioVisita, setHorarioVisita] = useState("");

    let horariosDisponiveis: string[] = [];

    const { Atendimento, updateAtendimento } = useAtendimentoPage();
    const { ReloadHistorico } = useHistoricoContext();

    const { execute: CadastrarVisita, loading: CadastrarVisitaLoading } =
        useAsyncCallback(CadastrarVisitaVendasController);

    function handleCadastrarVisita(formData: ICompromissoRequest) {
        const dataVisita = formData.DT_CASO_VISITA;
        const horarioVisita = formData.DT_HORARIO;

        const dataHoraVisita = `${dataVisita}T${horarioVisita}`;

        CadastrarVisita({
            ...formData,
            DT_CASO_VISITA: dataHoraVisita,
            ID_CASO: Atendimento?.ID_CASO
                ? Atendimento?.ID_CASO
                : props.caso?.ID_CASO ?? 0,
            ID_USUARIO_RESPONSAVEL: Atendimento?.ID_USUARIO_RESPONSAVEL
                ? Atendimento?.ID_USUARIO_RESPONSAVEL
                : props.caso?.ID_CASO,
        }).then(() => {
            props.setShow(false);
            if (props.updateList) {
                props.updateList();
            }

            if (Atendimento?.ID_CASO) {
                ReloadHistorico();
                updateAtendimento();
            }
        });
    }

    const {
        value: lstHorariosAgendadosPontoVenda,
        loading: lstHorariosAgendadosPontoVendaLoading,
    } = useAsyncEffect(async () => {
        if (dataVisita && (Atendimento?.ID_CASO || props.caso?.ID_CASO)) {
            return ListarHorariosAgendadosPontoVendaController(
                dataVisita,
                Atendimento?.ID_CASO ?? props.caso?.ID_CASO ?? 0
            );
        }
    }, [dataVisita, Atendimento?.ID_CASO, props.caso?.ID_CASO]);

    const {
        value: lstPontoVendasDisponivel,
        loading: lstPontoVendasDisponivelLoading,
    } = useAsyncEffect(async () => {
        if (horarioVisita && dataVisita) {
            return ListarPontoVendasDisponivelController(
                dataVisita,
                horarioVisita
            );
        }
    }, [horarioVisita, dataVisita]);

    lstHorariosAgendadosPontoVenda?.forEach((item) => {
        horariosDisponiveis.push(...item.HorariosDisponiveis);
    });

    return (
        <FormProvider {...FormMethods}>
            <UnForm handleSubmit={handleCadastrarVisita}>
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-6">
                            <UnForm.Input
                                label="Data"
                                name="DT_CASO_VISITA"
                                type="date"
                                registerOptions={{
                                    required: "Selecione uma data",
                                }}
                                onChange={(e) => {
                                    setDataVisita(e.target.value);
                                    setHorarioVisita("");
                                }}
                            />
                        </div>
                        {lstHorariosAgendadosPontoVendaLoading && (
                            <div className="col-md-6">
                                <div className="d-flex justify-content-center">
                                    <Spinner size="sm" color="primary" />
                                </div>
                            </div>
                        )}
                        {!lstHorariosAgendadosPontoVendaLoading && (
                            <div className="col-md-6">
                                <label htmlFor="DT_HORARIO">Horário</label>
                                <UnForm.Select
                                    id="DT_HORARIO"
                                    name="DT_HORARIO"
                                    registerOptions={{
                                        required: "Selecione um horário",
                                    }}
                                    onChange={(e) => {
                                        setHorarioVisita(e.target.value);
                                    }}
                                >
                                    {horariosDisponiveis.length === 0 ? (
                                        <option disabled>
                                            Não existem horários cadastrados
                                            para este dia
                                        </option>
                                    ) : (
                                        <>
                                            <option></option>
                                            {horariosDisponiveis.map((item) => (
                                                <option value={item}>
                                                    {item}
                                                </option>
                                            ))}
                                        </>
                                    )}
                                </UnForm.Select>
                            </div>
                        )}
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="row">
                        <div className="col-md-6">
                            <div className="form-group">
                                {lstPontoVendasDisponivelLoading && (
                                    <div className="d-flex justify-content-center">
                                        <Spinner size="sm" color="primary" />
                                    </div>
                                )}
                                {!lstPontoVendasDisponivelLoading && (
                                    <UnForm.Select
                                        label="Ponto de Venda"
                                        name="ID_PONTO_VENDA"
                                        registerOptions={{
                                            required:
                                                "Selecione um ponto de venda",
                                        }}
                                    >
                                        <option></option>
                                        {lstPontoVendasDisponivel?.map(
                                            (item) => (
                                                <option
                                                    value={item.ID_PONTO_VENDA}
                                                >
                                                    {item.DS_PONTO_VENDA}
                                                </option>
                                            )
                                        )}
                                    </UnForm.Select>
                                )}
                            </div>
                        </div>
                        <div className="col-md-6">
                            <UnForm.Select
                                label="Tipo de visita"
                                name="ID_TIPO_VISITA"
                            >
                                <option></option>
                                <option value={1}>Agendada</option>
                                <option value={2}>Espontânea</option>
                                <option value={3}>Retorno</option>
                            </UnForm.Select>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="form-group">
                        <UnForm.Textarea
                            label="Comentário"
                            name="DS_DESCRICAO"
                            registerOptions={{
                                required: "Insira um comentário",
                            }}
                        />
                    </div>
                </div>

                {/* <div className="col-md-12">
                    <div className="form-group">
                    <UnForm.LazySelect
                      controller={ListarPontosVendaController}
                      getDS={(ds) => ds.DS_PONTO_VENDA}
                      getKeyValue={(key) => key.ID_PONTO_VENDA}
                            label="Tipo de visita"
                            name="ID_TIPO_VISITA"
                        >
                            <option></option>
                        </UnForm.LazySelect>
                    </div>
                </div> */}

                <UnForm.SubmitButton
                    icon={faPlus}
                    color="success"
                    loading={CadastrarVisitaLoading}
                    disabled={CadastrarVisitaLoading}
                    loadingSize="sm"
                    className="w-100"
                >
                    Cadastrar Visita
                </UnForm.SubmitButton>
            </UnForm>
        </FormProvider>
    );
}
